import { computed, toValue } from 'vue';
import { useStore } from '@/store';
import { useTableQuery } from '@/composables/useTableQuery';
import {
  getReportParams,
  getReportParamsByTabIdAndGroupBy,
  getSavedColumnsForCurrentTab,
} from '@/store/modules/table';

export const useReportParams = () => {
  const store = useStore();
  const tableQueryApi = useTableQuery();

  const reportParams = computed(() => {
    void tableQueryApi.tableActiveTab.value;
    void tableQueryApi.tableActiveReports.value;
    void tableQueryApi.tableQuery.value;
    void tableQueryApi.tableQueryTemporary.value;
    void tableQueryApi.tableColumnsFiltersForCurrentTab.value;
    void store.savedColumnsInCurentPreset;
    void store.activePreset;
    void store.report.route;

    return getReportParams();
  });

  const savedColumnsForCurrentTab = computed(() => {
    void tableQueryApi.tableActiveTab.value;
    void tableQueryApi.tableActiveReports.value;
    void store.savedColumnsInCurentPreset;

    return getSavedColumnsForCurrentTab();
  });

  const savedColumnsInCurentPreset = computed(() => {
    void store.activePreset;

    return store.savedColumnsInCurentPreset;
  });

  const savedColumns = computed(() => {
    void store.activePreset;

    return store.savedColumns;
  });

  const presetsInfo = computed(() => store.presetsInfo);

  const activePreset = computed(() => toValue(store.activePreset));

  const activePresetData = computed(() => store.activePresetData);

  const savedGroups = computed(() => store.savedGroups);

  return {
    reportParams,
    savedColumnsForCurrentTab,
    savedColumnsInCurentPreset,
    savedColumns,
    presetsInfo,
    activePreset,
    activePresetData,
    savedGroups,
    getReportParams,
    getReportParamsByTabIdAndGroupBy,
    getSavedColumnsForCurrentTab,
  };
};
